export class DeviceValue {
    average: { [key: number]: number | undefined };
    peak: { [key: number]: number | undefined };

    constructor() {
        this.average = {};
        this.peak = {};
    }
}
